module.exports = __webpack_public_path__ + "img/jaixin.d625aa4f.gif";